const Level4 = ({
  currentImage,
  L0OuterL2,
  L0OuterL3,
  L0OuterL5,
  L0OuterL6,
  L4Business,
  L4Core,
  L4Leadership,
  L4Self,
}) => {
  return (
    <div className={`${currentImage !== "imagedivl4" ? "hidden" : ""}`}>
      <div className="" id="imagedivl4">
        <div>
          <img
            src="assets/images/outerL4 1.png"
            useMap="#lw04"
            className="w-80 h-80"
            alt=""
          />
          <map name="lw04" id="lw04">
            <area
              className="cursor-pointer"
              alt="L4 Outer L5"
              onClick={L0OuterL5}
              coords="1015,153,926,241,983,299,1013,347,1049,399,1072,460,1097,547,1216,544,1202,460,1169,353,1114,269"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Outer L6"
              onClick={L0OuterL6}
              coords="268,114,335,202,413,162,495,135,614,124,701,128,757,145,773,33,716,23,633,15,565,14,498,18,404,49"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Outer L2"
              onClick={L0OuterL2}
              coords="7,644,116,647,116,560,136,471,162,398,195,339,247,284,154,221,114,269,75,341,47,400,20,487"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Outer L3"
              onClick={L0OuterL3}
              coords="19,1202,540,1095,444,1071,368,1040,294,981,235,922,138,976,200,1045,272,1106,381,1167"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Business"
              onClick={L4Business}
              coords="619,620,841,838,1057,619"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Self"
              onClick={L4Self}
              coords="612,1057,390,845,609,621"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Leadership"
              onClick={L4Leadership}
              coords="610,614,388,395,172,613"
              shape="poly"
            />
            <area
              className="cursor-pointer"
              alt="L4 Core"
              onClick={L4Core}
              coords="612,615,834,391,616,176"
              shape="poly"
            />
          </map>
        </div>
      </div>
    </div>
  );
};

export default Level4;
